module.exports = __webpack_public_path__ + "img/philosophy_knowledge.93685284.webp";